// Zaległości podatkowe
export const taxArrears = (state = '', action) => { 
    switch (action.type) {
        case 'TAX_ARREARS_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const taxArrearsPrice = (state = '', action) => { 
    switch (action.type) {
        case 'TAX_ARREARS_PRICE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Zaległości ZUS
export const ZUSarrears = (state = '', action) => { 
    switch (action.type) {
        case 'ZUS_ARREARS_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const ZUSarrearsPrice = (state = '', action) => { 
    switch (action.type) {
        case 'ZUS_ARREARS_PRICE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Postępowanie egzekucyjne
export const enforcementProceedings = (state = '', action) => { 
    switch (action.type) {
        case 'ENFORCEMENT_PROCEEDINGS_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const enforcementProceedingsPrice = (state = '', action) => { 
    switch (action.type) {
        case 'ENFORCEMENT_PROCEEDINGS_PRICE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const prevYearRevenuesTwo = (state = '', action) => { 
    switch (action.type) {
        case 'PREV_YEAR_REVENUES_TWO_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueOldTwo = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_OLD_TWO_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueScoreOldTwo = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_SCORE_OLD_TWO_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueProfitOldTwo = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_PROFIT_OLD_TWO_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueLossExplanationOldTwo = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_LOSS_EXPLANATION_OLD_TWO_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const prevYearRevenues = (state = '', action) => { 
    switch (action.type) {
        case 'PREV_YEAR_REVENUES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueOld = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueScoreOld = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_SCORE_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueProfitOld = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_PROFIT_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueLossExplanationOld = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_LOSS_EXPLANATION_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenue = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueFrom = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_FROM_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueTo = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_TO_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueScore = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_SCORE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueProfit = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_PROFIT_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const revenueLossExplanation = (state = '', action) => { 
    switch (action.type) {
        case 'REVENUE_LOSS_EXPLANATION_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const checkAndLossAmortizationOld = (state = '', action) => { 
    switch (action.type) {
        case 'CHECK_AND_LOSS_AMORTIZATION_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const checkAndLossAmortizationTypeOld = (state = '', action) => { 
    switch (action.type) {
        case 'CHECK_AND_LOSS_AMORTIZATION_TYPE_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const profitFromSalesOld = (state = '', action) => { 
    switch (action.type) {
        case 'PROFIT_FROM_SALES_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const checkAndLossFrom = (state = '', action) => { 
    switch (action.type) {
        case 'CHECK_AND_LOSS_FROM_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const checkAndLossTo = (state = '', action) => { 
    switch (action.type) {
        case 'CHECK_AND_LOSS_TO_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const checkAndLossAmortization = (state = '', action) => { 
    switch (action.type) {
        case 'CHECK_AND_LOSS_AMORTIZATION_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const checkAndLossAmortizationTypeOldTwo = (state = '', action) => { 
    switch (action.type) {
        case 'CHECK_AND_LOSS_AMORTIZATION_TYPE_OLD_TWO_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const profitFromSales = (state = '', action) => { 
    switch (action.type) {
        case 'PROFIT_FROM_SALES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceFrom = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_FROM_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceTo = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_TO_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceFixedAssets = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_FIXED_ASSETS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceFixedAssetsOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_FIXED_ASSETS_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceTotalEquity = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_TOTAL_EQUITY_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceTotalEquityOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_TOTAL_EQUITY_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceBusinesslikeAndDurable = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_BUSINESSLIKE_AND_DURABLE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceBusinesslikeAndDurableOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_BUSINESSLIKE_AND_DURABLE_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceCoreCapital = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_CORE_CAPITAL_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceCoreCapitalOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_CORE_CAPITAL_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceAssets = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_ASSETS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceAssetsOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_ASSETS_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceLiabilitiesAndProvisions = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_LIABILITIES_AND_PROVISIONS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceLiabilitiesAndProvisionsOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_LIABILITIES_AND_PROVISIONS_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceWrestling = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_WRESTLING_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceWrestlingOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_WRESTLING_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceLongtermLiabilities = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_LONGTERM_LIABILITIES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceLongtermLiabilitiesOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_LONGTERM_LIABILITIES_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceShorttermReceivables = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_SHORTTERM_RECEIVABLES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceShorttermReceivablesOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_SHORTTERM_RECEIVABLES_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceCurrentLiabilities = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_CURRENT_LIABILITIES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceCurrentLiabilitiesOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_CURRENT_LIABILITIES_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceCash = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_CASH_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceCashOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_CASH_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceSumOfAssetsLiabilities = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_SUM_OF_ASSETS_LIABILITIES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const balanceSumOfAssetsLiabilitiesOld = (state = '', action) => { 
    switch (action.type) {
        case 'BALANCE_SUM_OF_ASSETS_LIABILITIES_OLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}